export default {"src":"/_next/static/media/shorthandLogo.adec98ef.svg","height":37,"width":46,"blurWidth":0,"blurHeight":0};